module.exports = {
      id: "proofread-usage",
      viewBox: "0 0 21.271 15.261",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#proofread",
      toString: function () {
        return this.url;
      }
    }